/** Date-range helpers for The Scene print guide (all in New York time). */
export const nyToday = () => new Date().toLocaleDateString('en-CA', { timeZone: 'America/New_York' });

export function addDays(iso: string, n: number): string {
  const [y, m, d] = iso.split('-').map(Number);
  const t = new Date(Date.UTC(y ?? 2026, (m ?? 1) - 1, (d ?? 1) + n, 12));
  return t.toISOString().slice(0, 10);
}

const fmt = (iso: string, opts: Intl.DateTimeFormatOptions) => {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(Date.UTC(y ?? 2026, (m ?? 1) - 1, d ?? 1, 12)).toLocaleDateString('en-US', { timeZone: 'UTC', ...opts });
};

/** "November 2026 Guide" for a whole calendar month, else "Events from Nov 1 to Nov 14, 2026". */
export function rangeTitle(from: string, to: string): string {
  const [fy, fm, fd] = from.split('-').map(Number);
  const lastDay = new Date(Date.UTC(fy ?? 2026, fm ?? 1, 0)).getUTCDate();
  if (fd === 1 && to === `${from.slice(0, 8)}${String(lastDay).padStart(2, '0')}`) return `${fmt(from, { month: 'long', year: 'numeric' })} Guide`;
  const sameYear = from.slice(0, 4) === to.slice(0, 4);
  return `Events from ${fmt(from, sameYear ? { month: 'short', day: 'numeric' } : { month: 'short', day: 'numeric', year: 'numeric' })} to ${fmt(to, { month: 'short', day: 'numeric', year: 'numeric' })}`;
}

export const PRESETS: { label: string; range: () => { from: string; to: string } }[] = [
  { label: 'November 2026', range: () => ({ from: '2026-11-01', to: '2026-11-30' }) },
  { label: 'December 2026', range: () => ({ from: '2026-12-01', to: '2026-12-31' }) },
  { label: 'Next 14 Days', range: () => ({ from: nyToday(), to: addDays(nyToday(), 13) }) },
  { label: 'Next 30 Days', range: () => ({ from: nyToday(), to: addDays(nyToday(), 29) }) },
];
